import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import PropertyCard from "../PropertyCard";
import { ArrowRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PropertiesShowcase() {
  const { t, lang } = useI18n();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/properties`, { params: { featured: true } })
      .then((r) => setProperties(r.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      id="properties"
      data-testid="properties-section"
      className="bg-[#F8F9FA] py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-5">{t.properties.overline}</p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium">
              {t.properties.title}
            </h2>
            <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">
              {t.properties.subtitle}
            </p>
          </div>
          <Link
            to="/properties"
            data-testid="properties-view-all"
            className="btn-secondary self-start"
          >
            {t.properties.viewAll}
            <ArrowRight size={16} weight="bold" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white h-[480px] animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {properties.slice(0, 3).map((p) => (
              <PropertyCard key={p.id} property={p} lang={lang} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
